// extracted by mini-css-extract-plugin
export var body = "event-module--body--8aa03";
export var grid = "event-module--grid--a4928";
export var logo = "event-module--logo--02c4b";
export var logos = "event-module--logos--36ff0";
export var register = "event-module--register--b8b22";
export var registerContainer = "event-module--register-container--6d06b";
export var speakerContainer = "event-module--speaker-container--b7aff";
export var speakerImg = "event-module--speaker-img--658e2";
export var speakerName = "event-module--speaker-name--3eaf5";
export var speakerText = "event-module--speaker-text--a662f";
export var speakerTitle = "event-module--speaker-title--7f6e8";
export var speakers = "event-module--speakers--593df";
export var webinarHeading = "event-module--webinar-heading--e8690";